




















































import { Component, Vue, Watch } from 'vue-property-decorator';

interface ToastMessage {
  id: string;
  title: string;
  message: string;
  variant: string;
  visible: boolean;
}

@Component({
  name: 'ErrorHandler',
  components: {}
})
export default class ErrorHandler extends Vue {
  showErrorModal: boolean = false;
  errorDetails: { [key: string]: string } | null = null;
  toasts: ToastMessage[] = [];

  private toastCounter = 0;

  showValidationErrors(errors: { [key: string]: string }) {
    this.errorDetails = errors;
    this.showErrorModal = true;
  }

  showApiError(title: string, message: string, variant: string = 'danger') {
    const toast: ToastMessage = {
      id: `toast-${++this.toastCounter}`,
      title,
      message,
      variant,
      visible: true
    };
    
    this.toasts.push(toast);
  }

  removeToast(index: number) {
    this.toasts.splice(index, 1);
  }

  getFieldLabel(field: string): string {
    const labels: { [key: string]: string } = {
      priceChangePercentage: this.$t('errorHandler.fields.priceChangePercentage') as string,
      piPercentage: 'PI, %',
      minimumSkuProfitability: this.$t('errorHandler.fields.minimumSkuProfitability') as string,
      marginChangePercentagePoints: this.$t('errorHandler.fields.marginChangePercentagePoints') as string,
      general: this.$t('errorHandler.fields.general') as string
    };
    
    return labels[field] || field;
  }

  // Методы для интеграции с существующими компонентами
  handleSaveError(error: any) {
    let message = this.$t('errorHandler.errors.saveError') as string;
    
    if (error && error.response && error.response.data) {
      if (typeof error.response.data === 'string') {
        message = error.response.data;
      } else if (error.response.data.message) {
        message = error.response.data.message;
      } else if (error.response.data.errors) {
        // Обработка ошибок валидации от бэкенда
        this.showValidationErrors(error.response.data.errors);
        return;
      }
    }
    
    this.showApiError(this.$t('errorHandler.errors.saveTitle') as string, message);
  }

  handleLoadError(error: any) {
    const message = (error.response && error.response.data && error.response.data.message) || this.$t('errorHandler.errors.loadError') as string;
    this.showApiError(this.$t('errorHandler.errors.loadTitle') as string, message);
  }

  handleNetworkError() {
    this.showApiError(
      this.$t('errorHandler.errors.networkTitle') as string,
      this.$t('errorHandler.errors.networkMessage') as string,
      'warning'
    );
  }

  showSuccessMessage(message: string) {
    this.showApiError(this.$t('errorHandler.messages.success') as string, message, 'success');
  }
}
